// ⚠ TEMPORARY — manual test for RouteError. NOT STAGED; delete this file and its route before committing.
/* eslint-disable formatjs/no-literal-string-in-jsx */
import { useRef, useState } from 'react';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// Bumped once per test deploy, and the ONLY change in the 'proof' deploy — so the number on screen says which
// build the browser is actually running (1 = baseline, 2 = fixes, 3 = proof of the no-Shift+F5 update).
const BUILD_MARKER = 1;

// ⚠ THE BUG — this page crashes the moment it opens. FIX IT BY HAND, push, and see whether the fixed
// page reaches you WITHOUT Shift+F5. The fix is one line: make readSession() return a session, e.g.
//   return { user: { name: 'Test user' } };
type Session = { user: { name: string } };
function readSession(): Session | undefined {
  return { user: { name: 'Test user' } };
}

function Boom(): never {
  throw new Error('Intentional crash from /crash-test');
}

export default function CrashTestPage() {
  const [crash, setCrash] = useState(false);
  const [showLine, setShowLine] = useState(true);
  const [translated, setTranslated] = useState(false);
  const lineRef = useRef<HTMLParagraphElement>(null);

  // What Chrome Translate does: swap React's text node for its own <font> element. React still thinks
  // its text node is a child of the <p>, so the next render that removes it calls removeChild and throws.
  const translate = () => {
    const p = lineRef.current;
    const text = p?.firstChild;
    if (!p || !text) return;
    const font = document.createElement('font');
    font.textContent = 'Bu satır tarayıcı tarafından çevrildi';
    p.replaceChild(font, text);
    setTranslated(true);
  };

  return (
    <Stack spacing={2} sx={{ p: 3 }}>
      <Typography variant="h3">Crash test (temporary)</Typography>
      <Typography variant="h2" component="p">Build marker: {BUILD_MARKER}</Typography>
      <Typography>Signed in as {readSession()!.user.name}</Typography>
      {crash && <Boom />}

      <Typography variant="h5">1. Plain render crash</Typography>
      <Button variant="contained" color="error" onClick={() => setCrash(true)} sx={{ alignSelf: 'flex-start' }}>
        Throw during render
      </Button>

      <Typography variant="h5">2. Browser translation (the live bug)</Typography>
      {/* The <span> sibling matters: with a lone text child React just sets textContent and never calls
          removeChild. Real pages always mix text with elements, as here. */}
      <p ref={lineRef}>
        {showLine ? 'This line is rendered by React.' : null}
        <span />
      </p>
      <Stack direction="row" spacing={1}>
        <Button variant="outlined" disabled={translated} onClick={translate}>
          a. Translate the line (like Chrome)
        </Button>
        <Button variant="contained" color="error" onClick={() => setShowLine(false)}>
          b. Re-render (remove the line)
        </Button>
      </Stack>
    </Stack>
  );
}
